exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2XBDTIVigBJDybhZvL-hU3{display:block;height:100%;position:relative;width:100%}._3aRLlClO7wY2OiqMkwRcGP{background-position:50%;background-repeat:no-repeat;background-size:contain;display:none;left:0;position:absolute;pointer-events:none;top:0}img[data-paused=true]+._3aRLlClO7wY2OiqMkwRcGP{display:block}._3vYn8QjoEvrXxHyqdn9ddZ{pointer-events:none}.nlSABoG9CSaJpsufv8WW9{object-fit:contain}.nlSABoG9CSaJpsufv8WW9[data-paused=true]{display:none}", ""]);

// exports
exports.locals = {
	"container": "_2XBDTIVigBJDybhZvL-hU3",
	"still": "_3aRLlClO7wY2OiqMkwRcGP _2XBDTIVigBJDybhZvL-hU3",
	"video": "_3vYn8QjoEvrXxHyqdn9ddZ _2XBDTIVigBJDybhZvL-hU3",
	"image": "nlSABoG9CSaJpsufv8WW9 _3vYn8QjoEvrXxHyqdn9ddZ _2XBDTIVigBJDybhZvL-hU3"
};